import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import ROUTES from "../../../../constants/routes";
import useActivePromotion from "../../../../hooks/useActivePromotion";
import "./ActivePromotionBanner.css";

function ActivePromotionBanner() {
    const { activePromotion } = useActivePromotion();
    const { pathname } = useLocation();
    const showBanner = useMemo(
        () =>
            !pathname.includes(ROUTES.HOME_INSURANCE.CONFIRM1) &&
            !pathname.includes(ROUTES.HOME_INSURANCE.LANDING) &&
            !pathname.includes(ROUTES.HOME_INSURANCE.STEP1) &&
            !!activePromotion,
        [activePromotion, pathname]
    );
    return (
        showBanner && (
            <div className="active-promotion-banner">
                Compra online y obtén {activePromotion.discountPercentage}% dscto.
            </div>
        )
    );
}

export default React.memo(ActivePromotionBanner);
